var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEllipsis(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 3,
    viewBox: "0 0 13 3",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33333 2.66666C2.06971 2.66666 2.66667 2.06971 2.66667 1.33333C2.66667 0.596952 2.06971 0 1.33333 0C0.596954 0 0 0.596952 0 1.33333C0 2.06971 0.596954 2.66666 1.33333 2.66666Z",
    fill: "#5F606D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33333 2.66666C7.06971 2.66666 7.66666 2.06971 7.66666 1.33333C7.66666 0.596952 7.06971 0 6.33333 0C5.59695 0 5 0.596952 5 1.33333C5 2.06971 5.59695 2.66666 6.33333 2.66666Z",
    fill: "#5F606D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 2.66666C12.0697 2.66666 12.6667 2.06971 12.6667 1.33333C12.6667 0.596952 12.0697 0 11.3333 0C10.597 0 10 0.596952 10 1.33333C10 2.06971 10.597 2.66666 11.3333 2.66666Z",
    fill: "#5F606D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsis);
export default __webpack_public_path__ + "static/media/Ellipsis.0221e40bc38f50667adfb9f4b1457f44.svg";
export { ForwardRef as ReactComponent };